import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import "./ContactContent.css";
import HomeNavbarmenu from "../HomeFolder/HomeNavbarmenu";
import HomeSideNavbar from "../HomeFolder/HomeSideNavbar";
import AOS from "aos";
import "aos/dist/aos.css";
import { ContactData } from "./ContactData.jsx";

function ContactContent() {
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  const toggleContent = (id) => {
    setExpandedId((prevId) => (prevId === id ? null : id));
  };

  const renderHTMLContent = (content, isExpanded) => {
    const previewLimit = 100;
    const shortContent =
      content.length > previewLimit
        ? content.slice(0, previewLimit) + "..."
        : content;

    const html = isExpanded ? content : shortContent;

    return (
      <div className={`expandable-content ${isExpanded ? "expanded" : ""}`}>
        <div
          className="expandable-inner"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </div>
    );
  };

  return (
    <>
      <div className="navbar-holder">
        <HomeNavbarmenu />
      </div>
      <div className="home-sidenavbar-holder">
        <HomeSideNavbar />
      </div>
      <div className="video-container" id="main">
        <title>L-TT Contact Us</title>
        {/* <h1 class="sr-only" tabIndex={0}>
          Contact Us
        </h1> */}
        <img
          src={
            process.env.PUBLIC_URL + "/images/Banners/contact-banner-mobile.png"
          }
          alt="home-banner"
          className="banner-img mobile-banner"
        />
        <img
          src={process.env.PUBLIC_URL + "/images/Banners/contact-banner.png"}
          alt="contact-banner"
          className="banner-img desktop-banner"
        />
        <ul className="breadcrumbs">
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/Home"
            >
              L&TT Home
            </NavLink>
            <span>/</span>
          </li>
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/Contact-Us"
            >
              Contact Us
            </NavLink>
          </li>
        </ul>
        <div className="all-headings-text-box">
          <h1 tabIndex={0}>L&TT Contact Us</h1>
          <p>
            Do you have questions or need support? Contact the L&TT team - we
            are here to help you along your learning journey.
          </p>
        </div>
        {/* <p data-aos="fade-up">
          Do you have questions or need support? Contact the L&TT team - we are
          here to help you along your learning journey.
        </p> */}
      </div>

      <div className="contact-team-container">
        <div className="contact-team-wrap">
          <div className="heading-box">
            <h2 className="main-headings">Contact Us</h2>
          </div>
          <div className="contact-team-extra-row">
            {ContactData.map((item) => {
              const isExpanded = expandedId === item.id;
              const hasLongContent = item.content && item.content.length > 100;

              return (
                <div
                  key={item.id}
                  className="contact-team-row"
                  data-aos="zoom-in-up"
                >
                  <div className="contact-team-box">
                    <h3>{item.title}</h3>
                    {renderHTMLContent(item.content, isExpanded)}
                    {hasLongContent && (
                      <button
                        onClick={() => toggleContent(item.id)}
                        className="read-more-btn"
                      >
                        {isExpanded ? "See less..." : "Read more..."}
                      </button>
                    )}
                    <img
                      src={item.icon}
                      alt="track icon"
                      className="title-icon"
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactContent;
